<template>
    <html></html>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {};
        },
        async created() {
            let sso = window.localStorage.getItem('sso');
            let isSSO = sso === "true";
            if (isSSO) {
                window.localStorage.removeItem('access_token');
                window.localStorage.removeItem('idleTimeLimit');
                window.localStorage.removeItem('access_token');
                window.localStorage.removeItem('refresh_token');
                window.localStorage.removeItem('lastActive');
                window.localStorage.removeItem('id_token');
                window.localStorage.removeItem('tenant');
                window.localStorage.removeItem('user');
                window.localStorage.removeItem('NoticeBoard_IsClose');
                window.localStorage.removeItem('isUpchatUser');
                window.localStorage.removeItem('isUpGPTUser');
                window.localStorage.removeItem('upchat_login');
            }
        },
    }
</script>
<style lang="css">
</style>